import React from "react";
import styles from "./Copyrights.module.css";

const Copyrights = () => {
  return (
    <div className={styles.termsContainer}>
      <h1>TERMS AND CONDITIONS OF USE</h1>

      <p>
        These Terms and Conditions of Use (“Terms”) constitute a legally binding
        agreement (“Agreement”) between Charles Technologies Private Limited (“SS
        Media”, “We”, “Us”, or “Our”) and You (“User”, “Your”) governing the use
        of the SS Media mobile application (“App”) and related services.
      </p>

      <p>
        By downloading, accessing, or using the App, You agree to be bound by
        these Terms. If You do not agree, please uninstall and discontinue using
        the App immediately.
      </p>

      <h2>A. ABOUT SS MEDIA</h2>
      <p>
        SS Media is a digital news and media platform that publishes short-format
        news and trending video content. All news articles are created and
        curated by the SS Media editorial team. Videos featured within the App
        are linked directly from SS Media’s official YouTube channel.
      </p>

      <h2>B. USER ACCESS AND ACCOUNT</h2>

      <h3>Login:</h3>
      <ul>
        <li>The App allows access through a mobile number and OTP verification.</li>
        <li>
          Upon login, You may optionally provide Your name and photo for display
          under Your profile section.
        </li>
      </ul>

      <h3>Account Responsibility:</h3>
      <ul>
        <li>
          You agree to provide accurate information during login or profile creation.
        </li>
        <li>
          You are responsible for maintaining the confidentiality of your login
          credentials and device.
        </li>
      </ul>

      <h3>Multiple Devices:</h3>
      <ul>
        <li>
          You may access Your account on multiple devices using the same mobile number.
        </li>
      </ul>

      <h3>Account Termination:</h3>
      <ul>
        <li>You may uninstall the App at any time.</li>
        <li>
          SS Media reserves the right to suspend or terminate access in case of
          misuse or violation of these Terms.
        </li>
      </ul>

      <h2>C. CONTENT AND USAGE</h2>

      <h3>News Content:</h3>
      <ul>
        <li>
          All news content available in the App is created, owned, and published by
          SS Media.
        </li>
        <li>
          The content is for informational purposes only and should not be treated
          as professional advice.
        </li>
      </ul>

      <h3>Video Content:</h3>
      <ul>
        <li>
          Videos displayed within the App are embedded or linked from SS Media’s
          official YouTube handle.
        </li>
        <li>
          Playback and sharing are subject to YouTube’s own Terms of Service.
        </li>
      </ul>

      <h3>Content Sharing:</h3>
      <ul>
        <li>
          The App allows You to share news or video links externally through
          supported social media or messaging platforms.
        </li>
        <li>
          Shared content must not be modified, misrepresented, or distributed for
          commercial use without written permission.
        </li>
      </ul>

      <h3>Prohibited Actions:</h3>
      <p>You agree not to:</p>
      <ul>
        <li>
          Copy, reproduce, or republish content from the App without permission.
        </li>
        <li>Use the App for unlawful, defamatory, or misleading purposes.</li>
        <li>
          Upload or transmit harmful code, scripts, or automated tools to disrupt
          App functionality.
        </li>
      </ul>

      <h2>D. ZERO-TOLERANCE POLICY</h2>
      <p>
        SS Media enforces a strict zero-tolerance policy for objectionable content
        and abusive behavior.
      </p>
      <p>
        Users can report any content published by SS Media or any comment posted by
        other individuals using the Feedback option available in the Right Menu.
      </p>
      <p>
        Any user who posts objectionable comments shall be held accountable and may
        face suspension or termination of their account.
      </p>
      <p>
        SS Media will review all reports and take necessary action within 24 hours,
        including removing the content and suspending the offending account.
      </p>

      <h2>E. INTELLECTUAL PROPERTY</h2>
      <p>
        All intellectual property rights in the App — including design, layout,
        editorial content, graphics, logos, and source code — belong exclusively to
        Charles Technologies Private Limited.
      </p>
      <p>
        Videos sourced from YouTube remain the intellectual property of SS Media’s
        YouTube channel.
      </p>
      <p>
        You are granted a limited, non-exclusive, non-transferable right to use the
        App solely for personal and lawful purposes.
      </p>

      <h2>F. USER FEEDBACK</h2>
      <p>
        The App includes a Feedback feature that allows You to submit comments,
        suggestions, or reports. By submitting feedback, You grant SS Media the
        right to use such input to improve the App without any obligation or
        compensation.
      </p>

      <h2>G. DISCLAIMER</h2>
      <p>
        The App and its content are provided on an “as-is” and “as-available”
        basis. While every effort is made to ensure accuracy, SS Media does not
        guarantee that all information will be error-free, complete, or updated at
        all times.
      </p>
      <p>SS Media is not responsible for:</p>
      <ul>
        <li>Technical issues affecting access to the App;</li>
        <li>
          External links or embedded video content hosted on third-party platforms;
        </li>
        <li>Any loss or damage resulting from reliance on App content.</li>
      </ul>

      <h2>H. LIMITATION OF LIABILITY</h2>
      <p>
        To the fullest extent permitted by law, SS Media, its affiliates, directors,
        employees, or partners shall not be liable for any indirect, incidental, or
        consequential damages arising out of:
      </p>
      <ul>
        <li>Your access or inability to access the App;</li>
        <li>Any inaccuracies or omissions in the content; or</li>
        <li>Any third-party content or links accessed through the App.</li>
      </ul>
      <p>Your sole remedy for dissatisfaction with the App is to discontinue use.</p>

      <h2>I. MODIFICATIONS AND UPDATES</h2>
      <p>
        SS Media reserves the right to update, modify, or revise these Terms at any
        time without prior notice. The updated version will be made available within
        the App and on the website{" "}
        <a
          href="https://ssmedia.app"
          target="_blank"
          rel="noreferrer"
        >
          https://ssmedia.app
        </a>
        . Continued use of the App after such changes constitutes Your acceptance of
        the revised Terms.
      </p>

      <h2>J. GOVERNING LAW AND JURISDICTION</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws
        of India, and any disputes shall be subject to the exclusive jurisdiction of
        the competent courts in Chennai, Tamil Nadu.
      </p>

      <h2>K. CONTACT INFORMATION</h2>
      <p>For any questions, feedback, or grievances regarding these Terms, please contact us through:</p>

      <p>
        📧{" "}
        <a href="mailto:developercharlestech@gmail.com">
          developercharlestech@gmail.com
        </a>
        <br />
        🏢 Charles Technologies Private Limited, Chennai, Tamil Nadu, India
      </p>

      <p className={styles.lastUpdated}>Last Updated: November 2025</p>
    </div>
  );
};

export default Copyrights;
